<script>
import EntityService from '@/services/entityService.js';
import DesenhoNumberService from '@/services/desenhoNumberService.js';

export default {
    name: 'ModalCriarDesenho',
    props: [
        "usuarioStore",
        "dado",
        "criandoDado",
        "controlesDesativados"
    ],
    emits: [
        "update:alteraDados",
        "update:alteraDado",
        "update:alteraCriandoDado"
    ],
    data() {
        return {
            formulario: {
                code: "",
                status: "Elaboração",
                CodeEqipment: "",
                typeEquipment: "",
                sizeDocument: "",
                pieceEquipment: "",
                destinyDsenho: "",
                fomatDocument: "",
                sequential: "",
                descriptionDes: "",
                numeroCliente: "",
                anexo: ""
            },
            salvando: false,
            gerando: false,
            statusOpcoes: [
                "Elaboração",
                "Elaborado",
                "Cancelado"
            ],
            formatoOpcoes: [
                "A0",
                "A1",
                "A2",
                "A3",
                "A4"
            ],
            destinoOpcoes: [
                "C – Cliente",
                "F – Fabricação",
                "M – Montagem"
            ],
            entityService: new EntityService('DesenhoNumber'),
            desenhoNumberService: new DesenhoNumberService()
        };
    },
    computed: {
        podeGerarNumeracao() {
            return (
                this.formulario.id && // Precisa estar salvo primeiro
                this.formulario.CodeEqipment &&
                this.formulario.typeEquipment &&
                this.formulario.sizeDocument &&
                this.formulario.pieceEquipment &&
                this.formulario.destinyDsenho &&
                this.formulario.fomatDocument &&
                !this.formulario.sequential // Ainda não tem numeração
            );
        }
    },
    methods: {
        alteraDados() {
            this.$emit('update:alteraDados');
        },
        alteraDado(update) {
            this.$emit('update:alteraDado', update);
        },
        alteraCriandoDado(update) {
            this.$emit('update:alteraCriandoDado', update);
        },
        fecharModal() {
            this.alteraCriandoDado({ criandoDado: false, dado: {} });
            this.limparFormulario();
        },
        limparFormulario() {
            this.formulario = {
                code: "",
                status: "Elaboração",
                CodeEqipment: "",
                typeEquipment: "",
                sizeDocument: "",
                pieceEquipment: "",
                destinyDsenho: "",
                fomatDocument: "",
                sequential: "",
                descriptionDes: "",
                numeroCliente: "",
                anexo: ""
            };
        },
        async salvarDesenho() {
            try {
                this.salvando = true;

                // Criar novo desenho
                const response = await this.entityService.insertOrUpdate(this.formulario);
                
                if (response && response.data && response.data.data) {
                    // Atualizar o formulário com o ID retornado
                    this.formulario.id = response.data.data.id;
                    this.formulario.code = response.data.data.code;
                    alert("Desenho salvo com sucesso! Agora você pode gerar a numeração.");
                } else {
                    alert("Desenho salvo com sucesso!");
                }
                
                this.alteraDados(); // Atualiza a lista
            } catch (error) {
                console.error("❌ Erro ao salvar desenho:", error);
                alert("Erro ao salvar desenho");
            } finally {
                this.salvando = false;
            }
        },
        async gerarNumeracao() {
            if (!this.formulario.id) {
                alert("Salve o desenho antes de gerar a numeração");
                return;
            }

            if (!this.podeGerarNumeracao) {
                alert("Preencha todos os campos obrigatórios (*) para gerar a numeração");
                return;
            }

            try {
                this.gerando = true;
                const result = await this.desenhoNumberService.gerarNumeracao(this.formulario.id);
                
                if (result.success) {
                    this.formulario.sequential = result.sequential;
                    alert(result.message || "Numeração gerada com sucesso!");
                    this.alteraDados(); // Atualiza a lista
                    this.fecharModal(); // Fecha o modal após gerar
                } else {
                    alert(result.message || "Erro ao gerar numeração");
                }
            } catch (error) {
                console.error("❌ Erro ao gerar numeração:", error);
                alert("Erro ao gerar numeração");
            } finally {
                this.gerando = false;
            }
        }
    },
    watch: {
        criandoDado(newVal) {
            if (newVal && this.dado) {
                // Se está criando, limpa o formulário
                this.limparFormulario();
            }
        }
    }
};
</script>

<template>
    <v-dialog
        :value="criandoDado"
        @input="fecharModal"
        max-width="900px"
        persistent
        :disabled="controlesDesativados"
    >
        <v-card>
            <v-card-title class="primary white--text">
                <v-icon left color="white">mdi-file-chart</v-icon>
                Novo Desenho
            </v-card-title>

            <v-card-text class="pt-6">
                <!-- Seção: Informações Básicas -->
                <div class="mb-4">
                    <h3 class="subtitle-1 mb-2">Informações Básicas</h3>
                    <v-divider class="mb-4"></v-divider>

                    <v-row>
                        <v-col cols="12" md="3">
                            <v-text-field
                                v-model="formulario.code"
                                label="ID"
                                readonly
                                outlined
                                dense
                                hide-details
                            />
                        </v-col>

                        <v-col cols="12" md="3">
                            <v-select
                                v-model="formulario.status"
                                :items="statusOpcoes"
                                label="Status"
                                outlined
                                dense
                                hide-details
                            />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formulario.sequential"
                                label="Número do Desenho"
                                readonly
                                outlined
                                dense
                                hide-details
                                hint="Será gerado automaticamente"
                            />
                        </v-col>
                    </v-row>
                </div>

                <!-- Seção: Dados para Numeração -->
                <div class="mb-4">
                    <h3 class="subtitle-1 mb-2">Dados para Numeração *</h3>
                    <v-divider class="mb-4"></v-divider>

                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formulario.CodeEqipment"
                                label="Código de Equipamento *"
                                outlined
                                dense
                                required
                            />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formulario.typeEquipment"
                                label="Tipo de Equipamento *"
                                outlined
                                dense
                                required
                            />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formulario.sizeDocument"
                                label="Modelo ou Tamanho *"
                                outlined
                                dense
                                required
                            />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formulario.pieceEquipment"
                                label="Parte do Equipamento *"
                                outlined
                                dense
                                required
                            />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6">
                            <v-select
                                v-model="formulario.destinyDsenho"
                                :items="destinoOpcoes"
                                label="Destino do Desenho *"
                                outlined
                                dense
                                required
                            />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-select
                                v-model="formulario.fomatDocument"
                                :items="formatoOpcoes"
                                label="Formato do Desenho *"
                                outlined
                                dense
                                required
                            />
                        </v-col>
                    </v-row>
                </div>

                <!-- Seção: Informações Adicionais -->
                <div class="mb-4">
                    <h3 class="subtitle-1 mb-2">Informações Adicionais</h3>
                    <v-divider class="mb-4"></v-divider>

                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="formulario.descriptionDes"
                                label="Título / Descrição"
                                outlined
                                dense
                            />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formulario.numeroCliente"
                                label="Número do Cliente"
                                outlined
                                dense
                            />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formulario.anexo"
                                label="Link do Arquivo"
                                outlined
                                dense
                            />
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>

            <v-card-actions class="pa-4 grey lighten-4">
                <!-- Botão Gerar Numeração (lado esquerdo) -->
                <v-btn
                    v-if="formulario.code && !formulario.sequential"
                    color="success"
                    @click="gerarNumeracao"
                    :loading="gerando"
                    :disabled="!podeGerarNumeracao || salvando"
                >
                    <v-icon left>mdi-auto-fix</v-icon>
                    Gerar Numeração
                </v-btn>

                <v-spacer></v-spacer>

                <!-- Botões principais -->
                <v-btn
                    text
                    @click="fecharModal"
                    :disabled="salvando || gerando"
                >
                    Cancelar
                </v-btn>
                <v-btn
                    color="primary"
                    @click="salvarDesenho"
                    :loading="salvando"
                    :disabled="gerando"
                >
                    <v-icon left>mdi-content-save</v-icon>
                    Salvar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped>
.subtitle-1 {
    font-weight: 600;
    color: #333;
}
</style>
